export var ONE_MB = 1024 * 1024;
export var DAY_IN_MS = 86400000;
